"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Container = _interopRequireDefault(require("react-bootstrap/Container"));
var _Row = _interopRequireDefault(require("react-bootstrap/Row"));
var _Col = _interopRequireDefault(require("react-bootstrap/Col"));
var _Button = _interopRequireDefault(require("react-bootstrap/Button"));
var _Form = _interopRequireDefault(require("react-bootstrap/Form"));
var _Modal = _interopRequireDefault(require("react-bootstrap/Modal"));
var _Spinner = _interopRequireDefault(require("react-bootstrap/Spinner"));
require("./css/BorrowerLeadGenerationTool.css");
var _reactDeviceDetect = require("react-device-detect");
var _youtube = _interopRequireDefault(require("react-player/youtube"));
var _axios = _interopRequireDefault(require("axios"));
var _useTranslation = _interopRequireDefault(require("./hooks/useTranslation.js"));
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /*
This component aims to replace all instances of borrower lead contact forms
in use by SWMC. It renders a generic form with minimal styling so that the
form can easily be customized in each implementation.

The getNumbers function filters the user's input to possible phone numbers.
The three arrays that follow are used to verify that props passed into
this component are expected inputs for the GENERATE_LEAD_API.

BorrowerLeadGenerationTool handles the main logic for the form.
When the form is initially rendered, all the inputs are managed by useState hooks
All text is rendered from the useTranslation hook based on the keys in the corresponding locales json files.
Constants are established based on passed props and browser data.

handleSubmit pulls the form data from useState hooks and builds an object with passed props.
While building the object, the passed props are checked against expected inputs for the GENERATE_LEAD_API.
Any props that do not match are still passed, but a warning is sent to the console along with the expected inputs.
The warning allows the developer to change the prop to an expected input.
The object is then used to either send an email or generate a lead based on whether or not a key exists.

When the form is initially loaded, the useEffect will auto populate the user's
information if there is a URL key. It will also generate the states list based
on the statesDomain and statesCode prop. If the props do not exist, SWMC.COM
is used by default. After the list is populated, the user's state is selected
based on their IP address.

The render statement will show the form, thank you content, or failure modal.
The forwardRef is added to the first name input so that the dev can scroll
to the form and render a custom title while the form is visible.
The form feilds include Reference Number, First Name, Last Name, Email, Phone,
State, Message, and TCPA Consent.
The disabled reference number input is shown for use in swmc.com/callme and
can be hidden by applying a display:none; style to the blg-col-0 element.

On successful submit, the form will be hidden and the thank you content will be shown.
This will cause the forwardRef to return a null node to the parent useCallback.
If the form fails to submit, then a modal is shown to have the user contact
lead.management@swmc.com directly.
*/
// Phone number filtering to just numbers that don't start with 0 or 1
function getNumbers(inVal) {
  var curChar = "";
  var okChars = "0123456789";
  var removeCharsFromPrefix = "01";
  var retVal = "";
  var tmpVal = inVal.trim();
  if (tmpVal !== "") {
    for (var i = 0; i < tmpVal.length; i++) {
      curChar = tmpVal.charAt(i);
      if (okChars.indexOf(curChar) !== -1) {
        if (retVal === "" && removeCharsFromPrefix.indexOf(curChar) !== -1) {
          //Do nothing
        } else {
          retVal += curChar;
        }
      }
    }
  }
  return retVal;
}

// Writable properties for GENERATE_LEAD_API as indicated by https://docs.google.com/spreadsheets/d/1MUCdGRs3-3XaDEB6lPV2-LWW_rnC4wuy-JKy4St1WuM/edit#gid=47818
// When updating this array, please also update the documentation above.
// Used to verify passed props are expected inputs for the GENERATE_LEAD_API
const apiKeys = ["active", "armLoanCode", "assignDate", "baseLoanAmount", "bestTimeContact", "branch", "clientBrowser", "clientIP", "clientOS", "competitiveOffer", "convertedToLoan", "costcoMemberId", "countyCode", "createDate", "currLoanUpb", "currentAmount", "currentMI", "debtsPayoff", "doNotCall", "downPayment", "escrowTransfer", "estCityTax", "estCountyTax", "estFloodIns", "estHzIns", "estSchoolTax", "estWindIns", "expireDate", "externalLeadId", "fixRate", "followUpDate", "followUpReminder", "imageGroupId", "imagingId", "leadPriority", "leadSource", "leadSourceKeyword", "leadStatus", "leadStatusKeyword", "lender", "loanActualType", "loanClosed", "loanOfficerUid", "loanOfficerEmail", "loanOfficerUniqueNameForWebsite", "loanPurpose", "loanPurposeKeyword", "mainBtnName", "mainBtnNameTru", "domainNameConsent", "mainBtnText", "miType", "noteRate", "occupancy", "offFeeDiscountPoint", "offFeeEscrow", "offFeeNotary", "offFeeOrig", "offFeeProcess", "offFeeRecord", "offFeeTitle", "offFeeTransferTax", "offFeeUnderWrite", "offLendCredit", "offerAmortType", "offerAmount", "offerCashoutAmount", "offerLoanProductCode", "offerLoanType", "offerLoanTypeKeyword", "offerMI", "offerPI", "offerRate", "offerTerm", "oldLoanNo", "oldLoanType", "oldPaymentDate", "oldTerm", "paymentType", "payoffAmount", "promoCode", "propertyAddressCity", "propertyAddressState", "propertyAddressStreet1", "propertyAddressStreet2", "propertyAddressZipCode", "propertyListingID", "propertyType", "propertyTypeKeyword", "propertyValue", "referrerId", "requestReceivedDate", "reverse", "showModalBackBtn", "showSWMCConsent", "showPropertyStateField", "taxInstallmentType", "testingLead", "thankYouVideoUrl", "thankYouVideoThumbnail", "truAppHomePageUrl", "uploadDate", "webPageURL", "showCustomizeLOApplyNowUrl", "showReactPlayerVideoWindow", "angelAiNotifyObj", "language", "showTruApprovalButton", "isBrokerLoanOfficer", "requestFromIframe", "consentVersion", "consentText", "continueBtnRedirectUrl", "loID"];

// Expected borrower and coBorrower keys for lead generation api
// Used to verify passed props are expected inputs for the GENERATE_LEAD_API
const apiKeysBorrowers = ["consentVersion", "TCPA_Consent_Given", "addressCity", "addressState", "addressStreet", "addressZipCode", "cellPhone", "dob", "email", "fax", "fico", "firstName", "gender", "lastName", "maritalStatus", "middleName", "phone", "ssn", "suffix", "workPhone"];

// Render the form with forwardRef to allow parent to know when the form is rendered.
const BorrowerLeadGenerationTool = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const formRef = (0, _react.useRef)(null);
  const [clientIP, setClientIP] = (0, _react.useState)("");
  const [email, setEmail] = (0, _react.useState)("");
  const [firstName, setFirstName] = (0, _react.useState)("");
  const [formLoading, setFormLoading] = (0, _react.useState)(false);
  const [lastName, setLastName] = (0, _react.useState)("");
  const [consentValue, setConsentValue] = (0, _react.useState)(true);
  const [leadNoGenerated, setLeadNoGenerated] = (0, _react.useState)("");
  const [phone, setPhone] = (0, _react.useState)("");
  const [showContactForm, setShowContactForm] = (0, _react.useState)(true);
  const [showFailModal, setShowFailModal] = (0, _react.useState)(false);
  const [showConsenSection, setShowConsenSection] = (0, _react.useState)(false);
  const [showThankYouContent, setShowThankYouContent] = (0, _react.useState)(false);
  const [state, setState] = (0, _react.useState)("");
  const [statesOptions, setStatesOptions] = (0, _react.useState)("");
  const [userLocation, setUserLocation] = (0, _react.useState)("");
  const [validated, setValidated] = (0, _react.useState)(false);
  const [message, setMessage] = (0, _react.useState)("");
  const [showClickToMoreOpt, setShowClickToMoreOpt] = (0, _react.useState)(true);
  const [truAppHomePageUrl, setTruAppHomePageUrl] = (0, _react.useState)("");
  const {
    t
  } = (0, _useTranslation.default)(props.language);
  const [showConfirmationModal, setShowConfirmationModal] = (0, _react.useState)(false);
  const [hashkey, setHashkey] = (0, _react.useState)(null);
  const [refinaceHashkey, setRefinaceHashkey] = (0, _react.useState)(null);

  //Below is the function to remove non-printable ASCII chars
  //and special chars from the pass string
  function removeNonAsciiSpecialCharacters(str) {
    //check if pass value is null or blank.
    //return empty string if pass value is null or blank
    if (str === null || str === "") {
      return "";
    } else {
      //convert the pass value to string
      str = str.toString();
      //remove non-printable ASCII chars and replace it with empty string
      str = str.replace(/[^\x20-\x7E]/g, "");
      //replace all special characters with empty string
      str = str.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}0-9\[\]\\\/]/g, "");
      //return updated string to calling function
      return str;
    }
  }
  //below props(domainNameConsent) is passed for the consent to be fetched as per domain from the leadGenerationConsent.json, if the domainName inside json is not present then either we need to add or it will take default name as swmc.com
  // Below code is used to fetch the consent from the json, json has added consent as per website domain like swmc.com, angelai.com etc and also has languages en or es, so if we want to use this consent then we need to pass props like domainName and language

  const domainNameConsent = props.domainNameConsent ? props.domainNameConsent : "swmc.com";
  const language = props.language ? props.language : "en";
  const [consentData, setConsentData] = (0, _react.useState)(null);
  const [loading, setLoading] = (0, _react.useState)(true);
  const [error, setError] = (0, _react.useState)(null);
  const appendConsentLinks = submitConsent => {
    const termsLink = getSwmcReferralLink("https://www.swmc.com/terms-and-conditions");
    const privacyPolicyLink = getSwmcReferralLink("https://www.swmc.com/privacy-policy");
    const updatedConsent = submitConsent.replace(/href='https:\/\/www.swmc.com\/terms-and-conditions'/gi, "href='".concat(termsLink, "'")).replace(/href='https:\/\/www.swmc.com\/privacy-policy'/gi, "href='".concat(privacyPolicyLink, "'"));
    return updatedConsent;
  };
  (0, _react.useEffect)(() => {
    const fetchConsentData = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_LEAD_GENERATION_CONSENT_JSON);
        const data = await response.json();
        const selectedDomain = data[domainNameConsent] ? domainNameConsent : "swmc.com";
        const domainData = data[selectedDomain];
        let consent = {
          submitButtonConsent: domainData.submit_button_consent[language],
          automatedPhoneSolicitationConsent: domainData.automated_phone_solicitation_consent[language],
          version: domainData.version
        };
        consent.submitButtonConsent.content = appendConsentLinks(consent.submitButtonConsent.content);
        setConsentData(consent);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchConsentData();
  }, []);

  // Function to replace only the button name, retaining the original prefix (e.g., "clicking" or "enlace")
  const replaceButtonName = content => {
    if (!content) return "";
    return content.replace(/<span class='button-name'>(.*?)<\/span>/, (match, p1) => {
      const parts = p1.split(" "); // Split the text inside the <span>
      const currentBtnName = parts.slice(1).join(" "); // Get everything except the first part (button name)
      // If the current button name matches the mainBtnName, return the original content
      if (currentBtnName.trim().toLowerCase() === mainBtnName.trim().toLowerCase()) {
        return match;
      }
      // Replace only the button name part (keep the first word unchanged)
      return "<span class='button-name'>".concat(parts[0], " ").concat(mainBtnName, "</span>");
    });
  };
  // Declare variables
  const queryParams = new URLSearchParams(window.location.search);
  const key = queryParams.get("key");
  const utmSource = queryParams.get("utm_source") || undefined;
  const utmMedium = queryParams.get("utm_medium") || undefined;
  const utmCampaign = queryParams.get("utm_campaign") || undefined;
  const utmContent = queryParams.get("utm_content") || undefined;
  const consentVersion = consentData ? consentData.version : undefined;
  const consentText = consentData ? consentData.automatedPhoneSolicitationConsent.content : undefined;
  const clientBrowser = _reactDeviceDetect.browserName + "-" + _reactDeviceDetect.browserVersion;
  const clientOS = _reactDeviceDetect.osName + "-" + _reactDeviceDetect.osVersion;

  // Set common values based on imported props
  const isBrokerLoanOfficer = props.isBrokerLoanOfficer ? props.isBrokerLoanOfficer : false;
  const requestFromIframe = props.requestFromIframe ? props.requestFromIframe : false;
  const leadSource = props.leadSource ? props.leadSource : "NET001";
  const loanOfficerUid = props.loanOfficerUid ? props.loanOfficerUid : "CSTC";
  const loanOfficerEmail = props.loanOfficerEmail ? props.loanOfficerEmail : "";
  const branch = props.branch ? props.branch !== "" ? props.branch : "058" : "058";
  const promoCode = props.promoCode ? props.promoCode : "";
  const statesCode = props.statesCode ? props.statesCode : "SUNWST000";
  const statesDomain = props.statesDomain ? props.statesDomain : "swmc.com";
  const mainBtnName = props.mainBtnName ? props.mainBtnName : t("text2");
  const mainBtnNameTru = props.mainBtnNameTru ? props.mainBtnNameTru : t("text5");
  const mainBtnText = props.mainBtnText ? props.mainBtnText : ""; /** Plain text field, since mainBtnName can have icons placed */
  const showSWMCConsent = props.showSWMCConsent !== undefined ? props.showSWMCConsent : true; /** default to true */
  const angelAiNotifyObj = props.angelAiNotifyObj ? props.angelAiNotifyObj : {};
  const showModalBackBtn = props.showModalBackBtn ? props.showModalBackBtn : false;
  const showPropertyStateField = props.showPropertyStateField !== undefined ? props.showPropertyStateField : true;
  const webPageURL = props.webPageURL ? props.webPageURL : window.location.href;
  const showCustomizeLOApplyNowUrl = props.showCustomizeLOApplyNowUrl ? props.showCustomizeLOApplyNowUrl : false;
  const showReactPlayerVideoWindow = props.showReactPlayerVideoWindow !== undefined ? props.showReactPlayerVideoWindow : true;
  const showTruApprovalButton = props.showTruApprovalButton !== undefined ? props.showTruApprovalButton : true;
  const handleContinueButtonClick = () => {
    const redirectUrl = props.continueBtnRedirectUrl;
    if (redirectUrl === "requestCallback") {
      setShowThankYouContent(false);
      setShowConfirmationModal(true);
    } else if (redirectUrl && redirectUrl !== "requestCallback") {
      window.location.href = redirectUrl + refinaceHashkey;
      setShowThankYouContent(false);
    } else {}
  };

  // Handler for the confirmation modal's Continue button
  const handleConfirmationContinue = () => {
    window.location.href = "https://www.swmc.com/angelai/conversation/5826a6f431786043fa117be609fa53c28ef4cfbe513c6f57b3865f68b8e706ac";
  };
  const playIconWhiteImg = "https://resources.swmc.com/swmc-images/play-icon-white.png";
  const thankYouVideoUrl = props.thankYouVideoUrl && typeof props.thankYouVideoUrl === "string" ? props.thankYouVideoUrl : "https://www.youtube.com/watch?v=XYijKau9uIE"; // this is latest video, came after D2cVp7lnzQo

  const thankYouVideoThumbnail = props.thankYouVideoThumbnail && typeof props.thankYouVideoThumbnail === "string" ? props.thankYouVideoThumbnail : "https://resources.swmc.com/swmc-images/Tru-Approval.jpg";
  let consentExtra1 = t("consent_extra1");
  if (mainBtnName) {
    let defaultMainButtonName = t("text2");
    if (mainBtnText) {
      consentExtra1 = consentExtra1.replace(defaultMainButtonName, mainBtnText);
    } else consentExtra1 = consentExtra1.replace(defaultMainButtonName, mainBtnName);
  }

  //REACT-335: Generate hash and submit it with lead number to Apply Now
  const generateHash = async (leadNo, loanOfficerUid) => {
    let paraObj = {
      expire: 720,
      parameters: {
        leadNumber: leadNo
      }
    };
    try {
      const res = await _axios.default.post(process.env.REACT_APP_SUNSOFT_API_GENERATE_SESSION_KEY, paraObj, {
        headers: {
          "Content-Type": "application/json"
        }
      });
      return res.data.key; // Return the hash key
    } catch (error) {
      console.error("Error in generating hash key from the lead number", error);
      return null; // Return null if there's an error
    }
  };
  const generateHashRefinance = async (leadNo, loanOfficerUid) => {
    try {
      // Create the parameters object with all required fields
      // Using the variables available in the current context
      let paraObj = {
        expire: 720,
        parameters: {
          workflow: "Refinance Calculator",
          newChat: true,
          newChatDisplayName: "Refinance Calculator",
          newChatType: "errand",
          consentGiven: "Yes",
          loanAppPresetLeadNumber: leadNo,
          interviewerUid: loanOfficerUid || "",
          // Use the variables from the component scope
          userEmail: email || "",
          userPhone: phone || "",
          firstName: firstName || "",
          lastName: lastName || "",
          propertyState: state || ""
        }
      };
      // console.log("Hash generation payload:", JSON.stringify(paraObj, null, 2));
      // Make the API call
      const res = await _axios.default.post(process.env.REACT_APP_SUNSOFT_API_GENERATE_SESSION_KEY, paraObj, {
        headers: {
          "Content-Type": "application/json"
        }
      });
      // console.log("Hash generation response:", res.data);
      return res.data.key; // Return the hash key
    } catch (error) {
      console.error("Error in generating hash key from the lead number", error);
      return null; // Return null if there's an error
    }
  };
  const cacheFormData = () => {
    const cacheData = {
      email,
      firstName,
      lastName,
      consentValue,
      phone,
      state,
      message
    };
    localStorage.setItem("formData", JSON.stringify(cacheData));
    localStorage.setItem("formCacheTime", Date.now());
  };
  const loID = (props === null || props === void 0 ? void 0 : props.loID) || null;
  const blof = queryParams.get("blof") || sessionStorage.getItem("blof") || null;
  const queryRlo = queryParams.get("rlo") || sessionStorage.getItem("rlo") || null;
  const rlo = loID ? loID : queryRlo ? queryRlo : null;

  //getSWMCReferalLink function  generates a url based on
  //if rlo or blof values exist. if not, return normal url
  const getSwmcReferralLink = (0, _react.useCallback)(url => {
    let newUrl;
    if (url && rlo && blof) {
      newUrl = "".concat(url, "?rlo=").concat(rlo, "&blof=").concat(blof);
    } else if (url && rlo && !blof) {
      newUrl = "".concat(url, "?rlo=").concat(rlo);
    } else if (url && !rlo && blof) {
      newUrl = "".concat(url, "?blof=").concat(blof);
    } else if (url && !rlo && !blof) {
      newUrl = url;
    }
    return newUrl;
  }, [rlo, blof]);
  (0, _react.useEffect)(() => {
    if (props.storeFormCache) {
      const cachedFormData = JSON.parse(localStorage.getItem("formData"));
      //console.log("Cached Form Data:", cachedFormData);
      if (cachedFormData) {
        setEmail(cachedFormData.email || "");
        setFirstName(cachedFormData.firstName || "");
        setLastName(cachedFormData.lastName || "");
        setConsentValue(cachedFormData.consentValue || true);
        setPhone(cachedFormData.phone || "");
        setState(cachedFormData.state || "");
        setMessage(cachedFormData.message || "");
      }
    }
  }, [props.storeFormCache]);
  (0, _react.useEffect)(() => {
    const isBrokerLoanOfficer = props.isBrokerLoanOfficer ? props.isBrokerLoanOfficer : false;
    const loanOfficerUid = props.loanOfficerUid ? props.loanOfficerUid : "CSTC";
    const loanOfficerEmail = props.loanOfficerEmail ? props.loanOfficerEmail : "";
    const loanOfficerUniqueNameForWebsite = loanOfficerEmail ? removeNonAsciiSpecialCharacters(loanOfficerEmail.split("@")[0]) : "";
    const truAppURL = props.truAppHomePageUrl ? props.truAppHomePageUrl : "";
    let url;
    if (isBrokerLoanOfficer) {
      url = "https://www.swmc.com/truapproval?blof=".concat(loanOfficerUid);
    } else if (loanOfficerUniqueNameForWebsite) {
      url = "https://www.swmc.com/truapproval/".concat(loanOfficerUniqueNameForWebsite);
    } else if (truAppURL && typeof truAppURL === "string") {
      url = truAppURL;
    } else {
      url = "https://www.swmc.com/truapproval/";
    }
    setTruAppHomePageUrl(url);
  }, [props.isBrokerLoanOfficer, props.loanOfficerUid, props.loanOfficerEmail, props.truAppHomePageUrl]);

  // Declare functional constants
  const handleFailClose = () => setShowFailModal(false);
  const goBackToFirstPage = () => setShowConsenSection(false);
  const closeModalWindow = () => {
    if (document.querySelector(".modal")) {
      document.getElementsByClassName("btn-close")[0].click();
    }
  };

  //first name validation
  const handleFirstName = evt => {
    let tempFirstName = evt.currentTarget.value;
    tempFirstName = removeNonAsciiSpecialCharacters(tempFirstName);
    if (tempFirstName) {
      if (tempFirstName.includes(" ") && lastName === "") {
        const name = tempFirstName.split(" ");
        let fName = name[0];
        let lName = name.slice(1).join(" ");
        setFirstName(fName.trim());
        setLastName(lName.trim());
      } else {
        setFirstName(tempFirstName.trim());
      }
    } else {
      setFirstName("");
    }
  };

  //last name validation
  const handleLastName = evt => {
    let tempLastName = evt.currentTarget.value;
    tempLastName = removeNonAsciiSpecialCharacters(tempLastName);
    if (tempLastName) {
      if (tempLastName.includes(" ") && firstName === "") {
        const name = tempLastName.split(" ");
        let fName = name[0];
        let lName = name.slice(1).join(" ");
        setFirstName(fName.trim());
        setLastName(lName.trim());
      } else {
        setLastName(tempLastName.trim());
      }
    } else {
      setLastName("");
    }
  };

  //remove trailing and leading space from email address
  const handleEmailAddress = evt => {
    let tempEmailAddress = evt.currentTarget.value;
    if (tempEmailAddress) {
      setEmail(tempEmailAddress.trim());
    } else {
      setEmail("");
    }
  };

  // Phone number validation
  const handleTelephoneNumber = evt => {
    // Save Phone number in local storage for Apply
    var tmpVal = getNumbers(evt.currentTarget.value).trim();
    var FirstThreeDigit = tmpVal.substring(0, 3);
    var FirstSixDigit = tmpVal.substring(0, 6);

    /* Below Pattern will check numbers between below ranges
        456, 555, 900,
        100, 101, ..., 199
        211, 311, ..., 911  ***811 removed
        370, 371, ..., 379
        960, 961, ..., 969
        800, 801, ..., 855  ***removed
        866, 877, 888, 800855
        */
    var patt = /^(1[0-9][0-9])|([2-7]11)|(911)|(37[0-9])|(96[0-9])|(456)|(555)|(866)|(877)|(888)|(900)$/;
    var patt2 = /^800855$/;
    if (patt.test(FirstThreeDigit)) {
      evt.currentTarget.value = "";
      return;
    } else if (patt2.test(FirstSixDigit)) {
      evt.currentTarget.value = "";
      return;
    }
    var curChar = "";
    var areaCode = "";
    var firstThree = "";
    var lastFour = "";
    var extension = "";
    if (tmpVal !== "") {
      for (var i = 0; i < tmpVal.length; i++) {
        curChar = tmpVal.charAt(i);
        if (i < 3) areaCode += curChar;
        if (i < 6 && i > 2) firstThree += curChar;
        if (i < 10 && i > 5) lastFour += curChar;
        if (i > 9) extension += curChar;
      }
    }
    var retVal = "";

    /* Do not put the parentesis if we only have the first three digits of the phone number.
    Once we are past that then start formatting the phone number. This was the main issue
    why the phone number couldn't be blanked out in it's entirety.*/
    if (areaCode !== "" && firstThree === "") retVal += areaCode;else if (areaCode !== "" && firstThree !== "") retVal += "(" + areaCode + ")";
    if (firstThree !== "") retVal += " " + firstThree;
    if (lastFour !== "") retVal += "-" + lastFour;
    if (extension !== "") retVal += " x" + extension;else setPhone(retVal);
  };
  const showPhoneSoliticationConsent = () => {
    setShowClickToMoreOpt(false);
  };
  const hidePhoneSoliticationConsent = () => {
    setShowClickToMoreOpt(true);
  };

  // Build request data to be sent to generate leads api and email.
  const buildObj = () => {
    let name, fName, lName;
    let obj = {
      borrower: {},
      coBorrower: {}
    };
    // Add all props to obj so that they can be sent to borrower leads.
    if (props) {
      for (const [key, value] of Object.entries(props)) {
        // don't send required props that are not expected by the api.
        if (key !== "statesCode" && key !== "statesDomain" && key !== "toEmailAddress" && key !== "webPageURL" && key !== "mainBtnName" && key !== "showModalBackBtn" && key !== "showPropertyStateField" && key !== "thankYouVideoUrl" && key !== "thankYouVideoThumbnail" && key !== "truAppHomePageUrl" && key !== "mainBtnText" && key !== "showCustomizeLOApplyNowUrl" && key !== "showReactPlayerVideoWindow" && key !== "showTruApprovalButton" && key !== "isBrokerLoanOfficer" && key !== "continueBtnRedirectUrl") {
          // build req data to be sent to generate leads api while filtering out invalid data.
          if (key !== "borrower" && key.toLowerCase() !== "coborrower" && value !== "") {
            obj[key] = value;
            if (!apiKeys.includes(key)) {
              // Warn the developer that the prop doesn't match any of the expected keys
              console.warn("Unexpected prop: ".concat(key, ". Props must align with lead generation api expectations. If this is a correct key, please update the apiKeys array in borrower-lead-generation-tool."), apiKeys);
            }
          } else if (key === "borrower") {
            if (typeof value !== "object") {
              // Alert the developer that the borrower prop must be an object
              console.error("Unexpected prop value for borrower: ".concat(value, ", expected an object"));
            } else {
              for (const [k, v] of Object.entries(value)) {
                if (v !== "") {
                  obj.borrower[k] = v;
                }
                if (!apiKeysBorrowers.includes(k)) {
                  // Warn the developer that the borrower object key doesn't match any of the expected keys
                  console.warn("Unexpected borrower key: ".concat(k, ". Keys must align with lead generation api expectations. If this is a correct key, please update the apiKeysBorrowers array in borrower-lead-generation-tool."), apiKeysBorrowers);
                }
              }
            }
          } else if (key.toLowerCase() === "coborrower") {
            if (typeof value !== "object") {
              // Alert the developer that the coBorrower prop must be an object
              console.error("Unexpected prop value for coBorrower: ".concat(value, ", expected an object"));
            } else {
              for (const [k, v] of Object.entries(value)) {
                if (v !== "") {
                  obj.coBorrower[k] = v;
                }
                if (!apiKeysBorrowers.includes(k)) {
                  console.warn(// Warn the developer that the coBorrower object key doesn't match any of the expected keys
                  "Unexpected coBorrower key: ".concat(k, ". Keys must align with lead generation api expectations. If this is a correct key, please update the apiKeysBorrowers array in borrower-lead-generation-tool."), apiKeysBorrowers);
                }
              }
            }
          }
        }
      }
    }

    // delete original coBorrower values if they are still empty as we are not adding data in this function.
    if (JSON.stringify(obj.coBorrower) === "{}") {
      delete obj.coBorrower;
    }

    // ensure that first and last name are populated when both are entered into a single name field
    // swmc.com/callme is the main source for this logic as it will hide the last name field.
    if (firstName.includes(" ") && lastName === "") {
      name = firstName.split(" ");
      fName = name[0];
      lName = name.slice(1).join(" ");
    } else if (lastName.includes(" ") && firstName === "") {
      name = lastName.split(" ");
      fName = name[0];
      lName = name.slice(1).join(" ");
    } else {
      fName = firstName;
      lName = lastName;
    }
    obj.borrower.TCPA_Consent_Given = consentValue;
    if (email !== "") {
      obj.borrower.email = email;
    }
    if (fName !== "") {
      obj.borrower.firstName = fName;
    }
    if (lName !== "") {
      obj.borrower.lastName = lName;
    }
    if (phone !== "") {
      obj.borrower.phone = phone;
    }
    obj.branch = branch;
    obj.clientBrowser = clientBrowser;
    obj.clientIP = clientIP;
    obj.clientOS = clientOS;
    obj.leadSource = leadSource;
    obj.loanOfficerUid = loanOfficerUid;
    obj.location = userLocation;
    obj.utmSource = utmSource;
    obj.utmMedium = utmMedium;
    obj.utmCampaign = utmCampaign;
    obj.utmContent = utmContent;
    obj.consentVersion = consentVersion;
    obj.consentText = consentText;
    if (message !== "") {
      obj.message = message;
    }
    if (state !== "" && showPropertyStateField) {
      obj.propertyAddressState = state;
    }
    if (promoCode !== "") {
      obj.promoCode = promoCode;
    }
    if (angelAiNotifyObj && typeof angelAiNotifyObj === "object") {
      obj.angelAiNotifyObj = angelAiNotifyObj;
    }
    return obj;
  };

  // Post requests to the lead generator will automatically send an email to lead.management@swmc.com.
  // Users that already have a lead number will not post to the lead generator.
  // This function should send an email whenever the lead generator does not and when additional emails need to be sent.
  // More data is expected to be sent here as this data would otherwise be lost.
  const sendEmail = (data, lead) => {
    // add the required keys to the data object to send the email.
    let emails;
    if (props.toEmailAddress) {
      emails = props.toEmailAddress + "," + process.env.REACT_APP_LEAD_MANAGEMENT_EMAIL;
    } else {
      emails = process.env.REACT_APP_LEAD_MANAGEMENT_EMAIL;
    }
    data.leadNumber = lead;
    data.toEmailAddress = emails;
    data.webPageURL = webPageURL;

    // Pass the key so that the contact api knows this came from email campaign.
    if (key) {
      data.key = key;
    }
    _axios.default.post(process.env.REACT_APP_CONTACT_API, data, {
      headers: {
        "Content-Type": "application/json"
      }
    }).catch(error => {
      console.error("borrower-lead-generation-tool Post #1", error);
    });
  };
  const handleSubmit = event => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      const borrowerLeadGenerationForm = formRef.current;
      // pull all available data from form submit and props passed from parent.
      let obj = buildObj();
      if (obj) {
        if (!showConsenSection) {
          if (key && leadNoGenerated || leadNoGenerated) {
            // If a key exists, do not generate a new lead
            setFormLoading(true);
            // Send email regarding successful email campaign with all available data.
            sendEmail(obj, leadNoGenerated);
            // Set the lead number so that it can be used to redirect the user
            setLeadNoGenerated(leadNoGenerated);
            // show the consent section.
            setShowConsenSection(true);
            setFormLoading(false);
          } else {
            setFormLoading(true);
            let start = Date.now();
            _axios.default.post(process.env.REACT_APP_GENERATE_LEAD_API, obj, {
              headers: {
                "Content-Type": "application/json"
              }
            }).then(async res => {
              let bodyResponse = res.data.body;
              // nested if statements avoid error of undefined leadNumber
              if (bodyResponse) {
                if (bodyResponse.leadNumber) {
                  const leadNo = bodyResponse.leadNumber;
                  const loanOfficerUid = obj.loanOfficerUid;

                  // Call generateHash and wait for the result
                  const newHash = await generateHash(leadNo, loanOfficerUid);
                  const newRefinanceHash = await generateHashRefinance(leadNo, loanOfficerUid);
                  // Update the state with the generated hash
                  setHashkey(newHash);
                  setRefinaceHashkey(newRefinanceHash);

                  //update tru approval button url as per loan officer if page is customized loan officer page
                  if (showCustomizeLOApplyNowUrl && showTruApprovalButton && !isBrokerLoanOfficer) {
                    if (bodyResponse.loanOfficerEmail !== "" && bodyResponse.loanOfficerEmail !== null && bodyResponse.loanOfficerEmail !== undefined) {
                      const loEmail = bodyResponse.loanOfficerEmail;
                      const loUniqueWebsiteName = removeNonAsciiSpecialCharacters(loEmail.split("@")[0]);
                      setTruAppHomePageUrl("https://www.swmc.com/truapproval/" + loUniqueWebsiteName);
                    }
                  }
                  // console.log(
                  //   `Posting to GENERATE_LEAD_API took ${
                  //     Date.now() - start
                  //   }ms (borrower-lead-generation-tool)`
                  // );
                  // Set the lead number so that it can be used to redirect the user
                  setLeadNoGenerated(leadNo);
                  // show the consent section.
                  setShowConsenSection(true);
                  setFormLoading(false);
                  const redirectUrl = props.continueBtnRedirectUrl || "";
                  if (redirectUrl && redirectUrl !== "requestCallback") {
                    // Ensure email is sent before redirection
                    sendEmail(obj, leadNo);
                    setShowThankYouContent(false);
                  }
                }
              }
            }).catch(error => {
              // Unique errors allow devs to quickly track down the problem.
              console.error("borrower-lead-generation-tool Post #2", error);
              // Set the phone number to empty string as it is not reset with the rest of the form.
              setPhone("");
              // show the fail modal and and hide the thank you content.
              setShowFailModal(true);
              setShowThankYouContent(false);
              // Reset the form data and end form loading so that the form can be submitted again.
              borrowerLeadGenerationForm.classList.remove("was-validated");
              borrowerLeadGenerationForm.reset();
              setFormLoading(false);
            }).finally(() => {
              // Cache form data if storeFormCache is true
              if (props.storeFormCache) {
                cacheFormData();
              }
              //console.log("Caching form data");
            });
          }
          if (Object.keys(angelAiNotifyObj).length > 0) {
            // angelAiNotificationMessage will record the messgae template which will be sent in the angelai notification.
            const angelAiNotificationMessage = "\n            <p><b>New Lead Alert - Act Fast!</b></p>\n            <p>Exciting news! A new lead has been generated from your site - ".concat(window.location.href, "</p>\n            <p>Here are the details:</p>\n              <p><b>Lead Name: </b> ").concat(firstName, " ").concat(lastName, "</p>\n              <p><b>Email: </b> ").concat(email, "</p>\n              <p><b>Phone: </b> ").concat(phone, "</p>\n              <p><b>Message: </b> ").concat(message, "</p>\n            <p>Please reach out to the client at your earliest convenience.</p>\n          ");
            _axios.default.post(process.env.REACT_APP_ANGELAI_NOTIFICATION, _objectSpread({
              attachments: [],
              sendEmailNotifs: true,
              message: angelAiNotificationMessage
            }, angelAiNotifyObj), {
              headers: {
                "Content-Type": "application/json"
              }
            }).then(response => {
              // console.log(response);
            }).catch(error => {
              console.error("Error sending Angel AI notification", error);
            });
          }
        } else {
          // We need to update the generated lead info again as there might be the case user may
          // select I do not consent in the consent section after lead is generated
          setFormLoading(true);
          obj.leadNumber = leadNoGenerated;
          let start = Date.now();
          _axios.default.post(process.env.REACT_APP_GENERATE_LEAD_API, obj, {
            headers: {
              "Content-Type": "application/json"
            }
          }).then(res => {
            let bodyResponse = res.data.body;
            // nested if statements avoid error of undefined leadNumber
            if (bodyResponse) {
              if (bodyResponse.leadNumber) {
                const leadNo = bodyResponse.leadNumber;
                // console.log(
                //   `Posting to GENERATE_LEAD_API took ${
                //     Date.now() - start
                //   }ms (borrower-lead-generation-tool)`
                // );
                // email data is sent to qc and lead.management automatically via lead-superUser
                // If a more verbose email is required then we can send it by passing a toEmailAddress prop.
                // or by expanding the REACT_APP_LEAD_MANAGEMENT_EMAIL variable with comas 'qc@swmc.com,lead.management@swmc.com',
                if (leadNo && props.toEmailAddress || leadNo &&
                // lead-service-superUser does not send emails to developers@swmc.com but this prevents spam.
                // Change env variable to your personal email for testing.
                process.env.REACT_APP_LEAD_MANAGEMENT_EMAIL !== "developers@swmc.com" && process.env.REACT_APP_LEAD_MANAGEMENT_EMAIL !== "qc@swmc.com" && process.env.REACT_APP_LEAD_MANAGEMENT_EMAIL !== "lead.management@swmc.com") {
                  sendEmail(obj, leadNo);
                }
                // Set the lead number so that it can be used to redirect the user
                setLeadNoGenerated(leadNoGenerated);
                // Hide the contact form and consent section, then show the thank you content form.
                setShowContactForm(false);
                setShowConsenSection(false);
                setShowThankYouContent(true);
              }
            }
          }).catch(error => {
            // Unique errors allow devs to quickly track down the problem.
            console.error("borrower-lead-generation-tool Post #2", error);
            // Set the phone number to empty string as it is not reset with the rest of the form.
            setPhone("");
            // show the fail modal and and hide the thank you content.
            setShowFailModal(true);
            setShowThankYouContent(false);
            // Reset the form data and end form loading so that the form can be submitted again.
            borrowerLeadGenerationForm.classList.remove("was-validated");
            borrowerLeadGenerationForm.reset();
            setFormLoading(false);
          });
        }
        setValidated(false);
      }
    }
    // required for the form to show validation ui elements.
    setValidated(true);
  };
  (0, _react.useEffect)(() => {
    if (key) {
      // Key will only exist for users redirected from email campaigns.
      // We want to keep the original lead number and pull enough data so the user can submit the form without adding additional info.
      let start0 = Date.now();
      _axios.default.post(process.env.REACT_APP_SUNSOFT_API_GET_SESSION_KEY, {
        key: key
      }, {
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        // console.log("response: " + JSON.stringify(response.data.parameters));
        let userData = response.data.parameters;
        if (userData.borrowerName) {
          // If the borrower name contains a space, split the first and last name.
          let name = userData.borrowerName.split(" ");
          setFirstName(name[0]);
          setLastName(name.slice(1).join(" "));
        } else {
          // If there is no borrower name, set the first and last name accordingly.
          if (userData.borrowerFirstName) {
            setFirstName(userData.borrowerFirstName);
          }
          if (userData.borrowerLastName) {
            setLastName(userData.borrowerLastName);
          }
        }
        setPhone(userData.borrowerPhone);
        setEmail(userData.emailAddress);
        setLeadNoGenerated(userData.leadNumber);
        return response;
      }).catch(error => {
        console.error("borrower-lead-generation-tool Get GET_SESSION_KEY Error: ", error);
      }).finally(() => {
        // console.log(
        //   `Below request to GET_SESSION_KEY took ${
        //     Date.now() - start0
        //   }ms (borrower-lead-generation-tool)`
        // );
      });
    }
  }, [key]);
  (0, _react.useEffect)(() => {
    if (showPropertyStateField) {
      let start1 = Date.now();
      // Get states from public endpoint
      _axios.default.post(process.env.REACT_APP_SUNSOFT_RESTSERVER_STATE_LIST,
      // Removed timeout for compliance so states list is always shown.
      {
        domain: statesDomain,
        companyCode: statesCode
      }, {
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        // Per Dennis, states should not be filtered on the front end.
        // The correct statesDomain should be used to fetch the correct states list.
        let validStates = response.data;
        if (validStates) {
          // Set the dropdown state list option.
          setStatesOptions(validStates.map((item, index) => /*#__PURE__*/_react.default.createElement("option", {
            key: index,
            value: item.code
          }, item.name)));
          let start3 = Date.now();
          _axios.default.post(process.env.REACT_APP_MAXMIND, {}, {
            headers: {
              "Content-Type": "application/json"
            }
          }, {
            timeout: 5000
          }).then(response => {
            if (response.data !== "IP Not Available" && response.data !== "Invalid Country") {
              setClientIP(response.data.userIP);
              let userLocation = response.data.userLocation;
              if (userLocation) {
                setUserLocation(userLocation.latitude + ", " + userLocation.longitude);
              }
              let zipcode = response.data.zipcode;
              if (zipcode) {
                let start4 = Date.now();
                _axios.default.get(process.env.REACT_APP_SUNSOFT_RESTSERVER_ZIPCODE + zipcode, {
                  headers: {
                    "Content-Type": "application/json"
                  }
                }, {
                  timeout: 5000
                }).then(response => {
                  if (response.data.state) {
                    setState(response.data.state);
                  }
                }).catch(error => {
                  console.error("borrower-lead-generation-tool Get ZIPCODE Error: ", error);
                }).finally(() => {
                  // console.log(
                  //   `Below request to ZIPCODE took ${
                  //     Date.now() - start4
                  //   }ms (borrower-lead-generation-tool)`
                  // );
                });
              }
            }
          }).catch(error => {
            console.error("borrower-lead-generation-tool Post MAXMIND Error: ", error);
          }).finally(() => {
            // console.log(
            //   `Below request to MAXMIND took ${
            //     Date.now() - start3
            //   }ms (borrower-lead-generation-tool)`
            // );
          });
        }
      }).catch(error => {
        console.error("borrower-lead-generation-tool STATE_LIST Error: ", error);
      }).finally(() => {
        // console.log(
        //   `Below request to STATE_LIST took ${
        //     Date.now() - start1
        //   }ms (borrower-lead-generation-tool)`
        // );
      });
    }
  }, [showPropertyStateField, statesDomain, statesCode]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "borrowerLeadGeneration"
  }, /*#__PURE__*/_react.default.createElement(_Container.default, {
    className: "blg-container",
    fluid: true
  }, /*#__PURE__*/_react.default.createElement(_Row.default, {
    className: "blg-row-0 shadow"
  }, /*#__PURE__*/_react.default.createElement(_Col.default, {
    sm: 12,
    className: showThankYouContent ? "blg-col-ty" : ""
  }, showContactForm && /*#__PURE__*/_react.default.createElement(_Form.default, {
    autoComplete: "off",
    method: "POST",
    noValidate: true,
    onSubmit: handleSubmit,
    ref: formRef,
    validated: validated
  }, /*#__PURE__*/_react.default.createElement(_Row.default, {
    className: "blg-row-1"
  }, leadNoGenerated && /*#__PURE__*/_react.default.createElement(_Col.default, {
    sm: 12,
    className: "blg-col-0"
  }, /*#__PURE__*/_react.default.createElement(_Form.default.Group, {
    controlId: "reference",
    className: "form-group"
  }, /*#__PURE__*/_react.default.createElement(_Form.default.Control, {
    "aria-label": t("reference"),
    disabled: true,
    onChange: e => setLeadNoGenerated(e.target.value),
    placeholder: t("reference"),
    type: "text",
    value: leadNoGenerated
  }))), /*#__PURE__*/_react.default.createElement(_Col.default, {
    md: 6,
    sm: 12,
    className: showConsenSection ? "d-none" : "d-block blg-col-1"
  }, /*#__PURE__*/_react.default.createElement(_Form.default.Group, {
    controlId: "firstName",
    className: "form-group"
  }, /*#__PURE__*/_react.default.createElement(_Form.default.Control, {
    "aria-label": t("firstname"),
    onChange: e => setFirstName(e.target.value),
    onBlur: handleFirstName,
    placeholder: t("firstname"),
    required: lastName === "",
    type: "text",
    value: firstName,
    ref: ref
  }), /*#__PURE__*/_react.default.createElement(_Form.default.Control.Feedback, {
    type: "invalid"
  }, t("firstnamevalidation")))), /*#__PURE__*/_react.default.createElement(_Col.default, {
    md: 6,
    sm: 12,
    className: showConsenSection ? "d-none" : "d-block blg-col-2"
  }, /*#__PURE__*/_react.default.createElement(_Form.default.Group, {
    controlId: "lastName",
    className: "form-group"
  }, /*#__PURE__*/_react.default.createElement(_Form.default.Control, {
    "aria-label": t("lastname"),
    onChange: e => setLastName(e.target.value),
    onBlur: handleLastName,
    placeholder: t("lastname"),
    required: firstName === "",
    type: "text",
    value: lastName
  }), /*#__PURE__*/_react.default.createElement(_Form.default.Control.Feedback, {
    type: "invalid"
  }, t("lastnamevalidation")))), /*#__PURE__*/_react.default.createElement(_Col.default, {
    md: 6,
    sm: 12,
    className: showConsenSection ? "d-none" : "d-block blg-col-3"
  }, /*#__PURE__*/_react.default.createElement(_Form.default.Group, {
    controlId: "email",
    className: "form-group"
  }, /*#__PURE__*/_react.default.createElement(_Form.default.Control, {
    "aria-label": t("email"),
    onChange: handleEmailAddress,
    pattern: "^[a-zA-Z0-9._\\-]+@([a-zA-Z0-9\\-]+\\.)+[a-zA-Z0-9\\-]{2,64}$",
    placeholder: t("email"),
    required: phone === "",
    type: "text",
    value: email
  }), /*#__PURE__*/_react.default.createElement(_Form.default.Control.Feedback, {
    type: "invalid"
  }, t("emailvalidation")))), /*#__PURE__*/_react.default.createElement(_Col.default, {
    md: 6,
    sm: 12,
    className: showConsenSection ? "d-none" : "d-block blg-col-4"
  }, /*#__PURE__*/_react.default.createElement(_Form.default.Group, {
    controlId: "phone",
    className: "form-group"
  }, /*#__PURE__*/_react.default.createElement(_Form.default.Control, {
    "aria-label": t("phone"),
    maxLength: 21,
    minLength: 14,
    onChange: handleTelephoneNumber,
    pattern: "^\\(?(\\d{3})\\)?-?\\s?(\\d{3})-?\\s?(\\d{4})[ ]*(( |x){1}[ ]?([0-9]){1,7}){0,1}$",
    placeholder: t("phone"),
    required: email === "",
    type: "text",
    value: phone
  }), /*#__PURE__*/_react.default.createElement(_Form.default.Control.Feedback, {
    type: "invalid"
  }, t("phonevalidation")))), showPropertyStateField ? /*#__PURE__*/_react.default.createElement(_Col.default, {
    sm: 12,
    className: showConsenSection ? "d-none" : "d-block blg-col-5"
  }, /*#__PURE__*/_react.default.createElement(_Form.default.Group, {
    controlId: "state",
    className: "form-group"
  }, /*#__PURE__*/_react.default.createElement(_Form.default.Select, {
    "aria-label": t("yourpropertystate"),
    onChange: e => setState(e.target.value),
    placeholder: t("yourpropertystate")
    //required={state === ''}
    ,
    value: state
  }, /*#__PURE__*/_react.default.createElement("option", {
    value: ""
  }, t("yourpropertystate")), statesOptions), /*#__PURE__*/_react.default.createElement(_Form.default.Control.Feedback, {
    type: "invalid"
  }, "Invalid"))) : "", /*#__PURE__*/_react.default.createElement(_Col.default, {
    sm: 12,
    className: showConsenSection ? "d-none" : "d-block blg-col-6"
  }, /*#__PURE__*/_react.default.createElement(_Form.default.Group, {
    controlId: "message",
    className: "form-group"
  }, /*#__PURE__*/_react.default.createElement(_Form.default.Control, {
    "aria-label": t("message"),
    as: "textarea",
    onChange: e => setMessage(e.target.value),
    placeholder: t("message"),
    rows: 3,
    value: message
  }))), /*#__PURE__*/_react.default.createElement(_Col.default, {
    sm: 12,
    className: showConsenSection ? "d-block blg-col-8" : "d-none"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex"
  }, showClickToMoreOpt ? /*#__PURE__*/_react.default.createElement("h6", {
    className: "consentSmall",
    onClick: showPhoneSoliticationConsent
  }, t("consent_small"), " ", /*#__PURE__*/_react.default.createElement("span", {
    id: "showConsentText",
    className: "consentLink showConsentText",
    title: t("show_title_text")
  }, t("show_consent_text"))) : /*#__PURE__*/_react.default.createElement("h6", {
    className: "consentSmall",
    onClick: hidePhoneSoliticationConsent
  }, t("consent_small"), " ", /*#__PURE__*/_react.default.createElement("span", {
    id: "hideConsentText",
    className: "consentLink hideConsentText",
    title: t("hide_title_text")
  }, t("hide_consent_text")))), !showClickToMoreOpt ? loading ? /*#__PURE__*/_react.default.createElement("p", null, "Loading...") : consentData !== null && consentData !== void 0 && consentData.automatedPhoneSolicitationConsent ? /*#__PURE__*/_react.default.createElement("p", {
    id: "phoneSolicitationTerms",
    className: "consent-font pb-0"
  }, (() => {
    try {
      return (0, _htmlReactParser.default)(consentData.automatedPhoneSolicitationConsent.content);
    } catch (error) {
      console.error("Error parsing consent content:", error);
      return null; // Render nothing if parsing fails
    }
  })()) : /*#__PURE__*/_react.default.createElement("p", {
    id: "phoneSolicitationTerms",
    className: "consent-font pb-0"
  }, "By clicking \u201CI Consent\u201D below, you expressly consent to Sun West Mortgage Company, Inc. making (or allowing Sun West Mortgage Company, Inc. employees and agents making, solely on Sun West Mortgage Company, Inc.\u2019s behalf) a phone call, text message or voicemail transmission to the phone number you entered above, for the purpose of soliciting your purchase of consumer services, including mortgage services (including using our automated system for the selection or dialing of phone numbers, the playing of a recorded message when a connection is made, or the transmission of a pre-recorded voicemail), even if the phone number you entered above is on a national, state, or internal Do Not Call Registry. You are not required to click on \u201CI Consent\u201D below (directly or indirectly) or agree to receive such phone calls, text messages, or voicemail transmissions as a condition of receiving any consumer services, including mortgage services from Sun West Mortgage Company, Inc. or its affiliates.") // Display message if consentData is missing
  : ""), /*#__PURE__*/_react.default.createElement(_Col.default, {
    sm: 12,
    className: showConsenSection ? "d-block blg-col-9" : "d-none"
  }, /*#__PURE__*/_react.default.createElement(_Form.default.Check, {
    "aria-label": t("consentlabel1"),
    defaultChecked: true,
    className: "checkIConsent",
    id: "iConsent",
    label: t("consentlabel1"),
    name: "checkIConsent",
    onClick: () => setConsentValue(true),
    type: "radio"
  }), /*#__PURE__*/_react.default.createElement(_Form.default.Check, {
    "aria-label": t("consentlabel2"),
    className: "checkIConsent",
    id: "iDoNotConsent",
    label: t("consentlabel2"),
    name: "checkIConsent",
    onClick: () => setConsentValue(false),
    type: "radio"
  })), /*#__PURE__*/_react.default.createElement(_Col.default, {
    sm: 12,
    className: showConsenSection ? "d-none" : "d-block blg-col-10"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "consent-font"
  }, loading ? /*#__PURE__*/_react.default.createElement("p", null, "Loading...") // Display a loading message while fetching data
  : consentData !== null && consentData !== void 0 && consentData.submitButtonConsent ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _htmlReactParser.default)(replaceButtonName(consentData.submitButtonConsent.content))) : /*#__PURE__*/_react.default.createElement("p", null, "By", " ", /*#__PURE__*/_react.default.createElement("span", {
    class: "button-name"
  }, "clicking Get Started"), " ", "below you agree to Sun West Mortgage Company, Inc.'s NMLS 3277 (\u201CSun West\u201D)", " ", /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.swmc.com/terms-and-conditions",
    target: "_blank",
    rel: "noreferrer noopener"
  }, "Terms and Conditions"), " ", "and", " ", /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.swmc.com/privacy-policy",
    target: "_blank",
    rel: "noreferrer noopener"
  }, "Security and Privacy Policy"), "; and you agree to Celligence International, LLC.'s (\u201CCelligence\u201D)", " ", /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.celligence.com/terms",
    target: "_blank",
    rel: "noreferrer noopener"
  }, "Terms and Conditions"), " ", "and", " ", /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.celligence.com/privacy",
    target: "_blank",
    rel: "noreferrer noopener"
  }, "Security and Privacy Policy"), ", all of which you may access by clicking on the \u201CTerms and Conditions\u201D or \u201CSecurity Policy\u201D web links contained herein.") // Handle case where data is not available
  )), /*#__PURE__*/_react.default.createElement(_Col.default, {
    sm: 12,
    className: showConsenSection ? "d-none" : "d-block blg-col-11"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "divflex"
  }, showModalBackBtn ? /*#__PURE__*/_react.default.createElement("div", {
    className: "backBtnDiv modalBackBtn"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "secondary",
    className: "btn-submit",
    type: "button",
    onClick: closeModalWindow
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, t("text10")))) :
  /*#__PURE__*/
  /** This is used to adjust button correctly*/
  _react.default.createElement("div", {
    className: "backBtnDiv modalBackBtn"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "whiteText"
  }, "\xA0")), /*#__PURE__*/_react.default.createElement("div", {
    className: "mainBtnDiv continueBtnDiv btnAdjustDiv"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "btn-submit",
    type: "submit"
  }, formLoading ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Spinner.default, {
    animation: "border",
    "aria-hidden": "true",
    as: "span",
    role: "status",
    size: "sm"
  }), " ", "Please wait...") : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _htmlReactParser.default)(mainBtnName))), props.showTruApprovalLogo && /*#__PURE__*/_react.default.createElement("div", {
    className: "tru-approval-logo-container"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "https://stagingresources.swmc.com/swmc-images/truapprovalogo.webp",
    alt: "TRU Approval",
    className: "tru-approval-logo"
  }))))), /*#__PURE__*/_react.default.createElement(_Col.default, {
    sm: 12,
    className: showConsenSection ? "d-block blg-col-12" : "d-none"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "divflex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "backBtnDiv"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "btn-submit",
    type: "button",
    onClick: goBackToFirstPage
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, t("text10")))), /*#__PURE__*/_react.default.createElement("div", {
    className: "continueBtnDiv btnAdjustDiv",
    id: "contunuebutton"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "btn-submit",
    type: "submit",
    variant: "success",
    onClick: handleContinueButtonClick
  }, formLoading ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Spinner.default, {
    animation: "border",
    "aria-hidden": "true",
    as: "span",
    role: "status",
    size: "sm"
  }), " ", "Please wait...") : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, t("text9")))), props.showTruApprovalLogo && /*#__PURE__*/_react.default.createElement("div", {
    className: "tru-approval-logo-container-second"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "https://stagingresources.swmc.com/swmc-images/truapprovalogo.webp",
    alt: "TRU Approval",
    className: "tru-approval-logo"
  })))))), showConfirmationModal && showThankYouContent ? /*#__PURE__*/_react.default.createElement("div", {
    className: "confirmation-content"
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Thank you for choosing Sun West!"), /*#__PURE__*/_react.default.createElement("p", null, "One of our licensed Loan Officers will be in touch with you shortly."), /*#__PURE__*/_react.default.createElement("p", null, "Click on", " ", /*#__PURE__*/_react.default.createElement("span", {
    onClick: handleConfirmationContinue,
    style: {
      cursor: "pointer"
    }
  }, /*#__PURE__*/_react.default.createElement("b", null, "Continue")), " ", "if you wish to submit an application."), /*#__PURE__*/_react.default.createElement(_Button.default, {
    size: "lg",
    variant: "success",
    onClick: handleConfirmationContinue
  }, "Continue")) : !showConfirmationModal && showThankYouContent && /*#__PURE__*/_react.default.createElement(_Row.default, {
    className: "blg-row-2"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "data:image/png;base64,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",
    className: "blg-img",
    alt: "SWMC Sun West Mortgage Company Form Submitted Successfully"
  }), /*#__PURE__*/_react.default.createElement(_Col.default, {
    sm: 12,
    className: "blg-col-12"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "text-blue pb-0"
  }, t("text3"), " ", leadNoGenerated)), /*#__PURE__*/_react.default.createElement(_Col.default, {
    sm: 12,
    className: "blg-col-13"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    id: "continue-application",
    className: "text-blue"
  }, t("text4"))), /*#__PURE__*/_react.default.createElement(_Col.default, {
    sm: 12,
    className: "blg-col-14 text-center"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    size: "lg",
    className: "btn-start",
    href: showCustomizeLOApplyNowUrl && loanOfficerUid ? process.env.REACT_APP_APPLY_NOW + "&leadNumber=" + leadNoGenerated + "&lof=" + loanOfficerUid + "&hash=" + hashkey : process.env.REACT_APP_APPLY_NOW + "&leadNumber=" + leadNoGenerated + "&hash=" + hashkey,
    target: "_blank",
    rel: "noreferrer noopener"
    // onClick={() => generateHash(leadNoGenerated, loanOfficerUid)} //Use arrow function so it won't executed at load
    //target="_blank"
    //rel="noreferrer noopener"
  }, t("text6"))), /*#__PURE__*/_react.default.createElement(_Col.default, {
    sm: 12,
    className: "blg-col-15 pt-2"
  }, showReactPlayerVideoWindow ? /*#__PURE__*/_react.default.createElement("div", {
    className: "player-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_youtube.default, {
    className: "react-player",
    url: thankYouVideoUrl,
    width: "100%",
    height: "100%",
    light: thankYouVideoThumbnail,
    playing: true,
    controls: true
  })) : /*#__PURE__*/_react.default.createElement("div", {
    className: "text-center position-relative"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("a", {
    href: thankYouVideoUrl,
    target: "_blank",
    rel: "noreferrer noopener"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: thankYouVideoThumbnail,
    alt: "Tru Approval Thank You Video",
    className: "img-fluid"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "playIconWhite"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: thankYouVideoUrl,
    target: "_blank",
    rel: "noreferrer noopener"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: playIconWhiteImg,
    alt: "play-icon",
    className: "mt-2"
  }))))), showTruApprovalButton && /*#__PURE__*/_react.default.createElement(_Col.default, {
    sm: 12,
    className: "blg-col-16 text-center pt-2"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    size: "lg",
    variant: "outline-primary",
    className: "btn-blg",
    href: truAppHomePageUrl,
    target: "_blank",
    rel: "noreferrer noopener"
  }, (0, _htmlReactParser.default)(mainBtnNameTru))))))), /*#__PURE__*/_react.default.createElement(_Modal.default, {
    size: "lg",
    centered: true,
    show: showFailModal,
    onHide: handleFailClose,
    backdrop: "static"
  }, /*#__PURE__*/_react.default.createElement(_Modal.default.Body, null, t("text7"), " \xA0", /*#__PURE__*/_react.default.createElement("a", {
    href: "mailto:inquiry@swmc.com",
    className: "form-link"
  }, "inquiry@swmc.com"), "."), /*#__PURE__*/_react.default.createElement(_Modal.default.Footer, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: handleFailClose
  }, t("text8")))));
});
var _default = exports.default = BorrowerLeadGenerationTool;